import axios from 'axios'

axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const controller = 'ActivityLog'

export const sendActivityLog = (headers={}) => {
  return axios.post(`/${controller}`,null,{headers})
}
